// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { RangePicker } from '../../../components/ant/DatePicker';

import { formatDateTimeToISOString } from '../../../lib/helpers';

import {
  Filter,
  FilterContainer,
  FilterItem,
  FilterButtonsContainer } from
'../../../components';

import Field from '../../../components/card/Field';

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-1offygo-0" })(["padding:16px;"]);














export const VehicleMonitoringFilter = ({
  style,
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent style={{ ...style }}>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              format="DD.MM.YYYY"
              size="small"
              placeholder={['Начало', 'Конец']}
              value={[
              values.startDate ? moment.utc(values.startDate) : null,
              values.endDate ? moment.utc(values.endDate) : null]
              }
              onChange={(value, dateString) => {
                const [startDate, endDate] = value;
                const [startDateString, endDateString] = dateString;
                changeValue(
                  'startDate',
                  formatDateTimeToISOString(startDate, startDateString)
                );
                changeValue(
                  'endDate',
                  formatDateTimeToISOString(endDate, endDateString)
                );
              }} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default VehicleMonitoringFilter;
